"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BitbucketOutputIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 15v1.994C7 18.103 7.898 19 9.006 19h9.988A2.005 2.005 0 0 0 21 16.994V7.006A2.005 2.005 0 0 0 18.994 5H9.006A2.005 2.005 0 0 0 7 7.006V9h2.003c0-1.175.002-2 .003-2 0 0 9.994.002 9.994.006 0 0-.002 9.994-.006 9.994 0 0-9.994-.002-9.994-.006V15z"/><path d="M8 6h12v3H8zM4.29 9.29l-1.99 2a1 1 0 0 0 0 1.42l1.99 2a1 1 0 0 0 1.41 0 .996.996 0 0 0 0-1.41L4.41 12l1.29-1.29A1 1 0 0 0 4.29 9.3"/><rect width="12" height="2" x="3" y="11" rx="1"/></g></svg>`
}, props));
BitbucketOutputIcon.displayName = 'BitbucketOutputIcon';
var _default = exports.default = BitbucketOutputIcon;